export default  [
    {
        "children": [
            {
                "value": 1526,
                "label": "T恤",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1527,
                "label": "针织衫/毛衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1528,
                "label": "夹克",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1529,
                "label": "卫衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1534,
                "label": "Polo衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1535,
                "label": "衬衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1545,
                "label": "风衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1552,
                "label": "棉衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1554,
                "label": "羽绒服",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1555,
                "label": "毛呢大衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 10672,
                "label": "西服",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1539,
                        "label": "西裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10673,
                        "label": "西服上衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10674,
                        "label": "西服套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 10676,
                "label": "套装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 10677,
                        "label": "休闲运动套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10678,
                        "label": "时尚套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10679,
                        "label": "其他套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 30064,
                        "label": "工装制服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 10681,
                "label": "羊毛衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 10682,
                "label": "防晒服",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 10683,
                        "label": "男士皮肤衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10684,
                        "label": "男士防晒衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10685,
                        "label": "男士防晒裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 10688,
                "label": "裤子",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1525,
                        "label": "休闲裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1531,
                        "label": "牛仔裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1541,
                        "label": "皮裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1557,
                        "label": "羽绒裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1559,
                        "label": "棉裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1562,
                        "label": "短裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10689,
                        "label": "背带裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10690,
                        "label": "卫裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 10691,
                "label": "工装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 10692,
                        "label": "工装上衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10693,
                        "label": "工装裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10694,
                        "label": "工装套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 10695,
                "label": "学生校服/工作制服",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 10696,
                        "label": "酒店工作制服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10698,
                        "label": "学生校服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10699,
                        "label": "医护制服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10697,
                        "label": "其他制服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 10700,
                "label": "连体衣/裤",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 21107,
                "label": "民族服装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 21908,
                        "label": "男士秀禾服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21909,
                        "label": "唐装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21910,
                        "label": "中山装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21108,
                "label": "羊绒衫",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 21913,
                        "label": "羊绒背心",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21914,
                        "label": "羊绒开衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21915,
                        "label": "羊绒套衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21109,
                "label": "中老年男装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 21917,
                        "label": "中老年上装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21918,
                        "label": "中老年下装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21919,
                        "label": "中老年套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21110,
                "label": "大码男装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 21920,
                        "label": "大码上装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21921,
                        "label": "大码下装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21922,
                        "label": "大码套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21905,
                "label": "马甲",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 21906,
                "label": "背心",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 21911,
                "label": "皮草",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 21912,
                "label": "皮衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 21916,
                "label": "羽绒马甲",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 29108,
                "label": "保暖背心",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 29109,
                "label": "仿皮草",
                "hierarchy": 2,
                "open": true,
                "children": []
            }
        ],
        "hierarchy": 1,
        "label": "男装",
        "value": 1524,
        "open": true
    },
    {
        "children": [
            {
                "value": 1584,
                "label": "连衣裙",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1588,
                "label": "T恤",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1604,
                "label": "衬衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1609,
                "label": "半身裙",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1613,
                "label": "短外套",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1620,
                "label": "风衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1622,
                "label": "羽绒服",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1624,
                "label": "毛呢外套",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1626,
                "label": "皮草",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1627,
                "label": "卫衣/绒衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1628,
                "label": "毛衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1629,
                "label": "棉衣/棉服",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 1630,
                "label": "马夹/坎肩",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9012,
                "label": "裤子",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1591,
                        "label": "休闲裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1598,
                        "label": "棉裤/羽绒裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1599,
                        "label": "皮裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1606,
                        "label": "牛仔裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2864,
                        "label": "短裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9013,
                        "label": "女士卫裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9014,
                        "label": "提臀裤/收腹裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9015,
                        "label": "背带裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9016,
                        "label": "工装裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 9021,
                "label": "羊毛衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9022,
                "label": "羊绒衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9058,
                "label": "抹胸上衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9023,
                "label": "毛针织衫",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 9024,
                        "label": "套头针织衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9025,
                        "label": "针织开衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 9026,
                "label": "蕾丝衫/雪纺衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9027,
                "label": "连体衣/裤",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9028,
                "label": "派克服",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9032,
                "label": "皮衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 9043,
                "label": "防晒类",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 9045,
                        "label": "女士防晒裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9046,
                        "label": "女士防晒服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 9047,
                "label": "婚纱/旗袍/礼服",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1633,
                        "label": "礼服/晚装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1634,
                        "label": "婚纱",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9048,
                        "label": "旗袍",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9049,
                        "label": "秀禾服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 9050,
                "label": "唐装/民族服装/舞台服装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 9051,
                        "label": "民族服装/舞台装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9052,
                        "label": "唐装/传统中式服装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 41036,
                        "label": "新中式服装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 9054,
                "label": "内搭",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1596,
                        "label": "打底裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9056,
                        "label": "背心/吊带",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9060,
                        "label": "打底衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 9061,
                "label": "套装/学生校服/工作制服",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 9034,
                        "label": "酒店工作制服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9062,
                        "label": "职业女裤套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9035,
                        "label": "学生校服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9063,
                        "label": "职业女裙套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9036,
                        "label": "医护制服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9064,
                        "label": "休闲套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 9065,
                        "label": "其他套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 41037,
                        "label": "时尚套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21102,
                "label": "大码女装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 21857,
                        "label": "大码T恤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21858,
                        "label": "大码西装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21859,
                        "label": "大码半身裙",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21860,
                        "label": "大码裤装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21861,
                        "label": "大码连衣裙",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21862,
                        "label": "大码棉服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21863,
                        "label": "大码大衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21864,
                        "label": "大码内搭",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21865,
                        "label": "大码套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21866,
                        "label": "大码羽绒服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21867,
                        "label": "大码衬衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21103,
                "label": "西装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1593,
                        "label": "西装裤/正装裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21871,
                        "label": "西服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21872,
                        "label": "西装套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21104,
                "label": "中老年女装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 21873,
                        "label": "中老年上装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21874,
                        "label": "中老年下装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21875,
                        "label": "中老年套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21876,
                        "label": "中老年裙装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21869,
                "label": "真丝上衣",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 21870,
                "label": "POLO衫",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 29085,
                "label": "仿皮草",
                "hierarchy": 2,
                "open": true,
                "children": []
            },
            {
                "value": 41003,
                "label": "夹克",
                "hierarchy": 2,
                "open": true,
                "children": []
            }
        ],
        "hierarchy": 1,
        "label": "女装",
        "value": 1582,
        "open": true
    },
    {
        "children": [
            {
                "value": 10286,
                "label": "运动服",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1807,
                        "label": "运动卫衣/套头衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1809,
                        "label": "运动棉衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1810,
                        "label": "运动羽绒服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1811,
                        "label": "运动夹克/外套",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1812,
                        "label": "运动T恤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1813,
                        "label": "运动套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1814,
                        "label": "运动POLO衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 3461,
                        "label": "运动背心",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 3462,
                        "label": "运动袜",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10287,
                        "label": "健身服装",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 10290,
                                "label": "健身衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10292,
                                "label": "健身裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10293,
                                "label": "健身套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 10288,
                        "label": "运动裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 10295,
                                "label": "运动牛仔裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10296,
                                "label": "运动长裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10297,
                                "label": "运动中长裤／短裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 10289,
                        "label": "运动内衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 10298,
                                "label": "运动文胸",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10299,
                                "label": "运动内裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10300,
                                "label": "运动内衣套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21152,
                        "label": "运动马甲",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22310,
                                "label": "单马甲",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22311,
                                "label": "棉马甲",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22312,
                                "label": "羽绒马甲",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21153,
                        "label": "运动球服",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22313,
                                "label": "篮球服",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22314,
                                "label": "足球服",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22315,
                                "label": "棒球服",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22317,
                                "label": "高尔夫球服",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22318,
                                "label": "其他球服",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21154,
                        "label": "运动裙",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22319,
                                "label": "运动半身裙",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22320,
                                "label": "运动连衣裙",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21155,
                        "label": "跑步服",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22321,
                                "label": "跑步套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22322,
                                "label": "跑步外套",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22323,
                                "label": "跑步裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22324,
                                "label": "跑步T恤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 22325,
                        "label": "运动毛衣/线衫",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 1785,
                "label": "运动鞋",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 1789,
                        "label": "篮球鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1791,
                        "label": "跑步鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1793,
                        "label": "运动板鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1796,
                        "label": "羽毛球鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1797,
                        "label": "网球鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1799,
                        "label": "乒乓球鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1801,
                        "label": "综合训练鞋/室内健身鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1803,
                        "label": "健步鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 3459,
                        "label": "运动休闲鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 3460,
                        "label": "帆布鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10302,
                        "label": "运动拖鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10303,
                        "label": "排球鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1806,
                        "label": "其他运动鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 30011,
                        "label": "童鞋/青少年鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 1945,
                "label": "户外服装",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 3528,
                        "label": "滑雪衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1952,
                        "label": "钓鱼服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1967,
                        "label": "冲浪鞋服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1973,
                        "label": "潜水服",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1990,
                        "label": "运动户外风衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 3466,
                        "label": "户外T恤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 3467,
                        "label": "户外袜",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 10304,
                        "label": "冲锋衣裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 10305,
                                "label": "冲锋衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10306,
                                "label": "冲锋裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10307,
                                "label": "冲锋衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 10308,
                        "label": "户外休闲衣裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 10309,
                                "label": "户外休闲衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10310,
                                "label": "户外休闲裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 10311,
                                "label": "户外休闲衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 10312,
                        "label": "运动户外防晒衣",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 1997,
                        "label": "其他户外服装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 21156,
                        "label": "速干衣裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22326,
                                "label": "速干T恤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22327,
                                "label": "速干裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22328,
                                "label": "速干衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22329,
                                "label": "速干衬衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22330,
                                "label": "速干背心",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21157,
                        "label": "软壳衣裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22331,
                                "label": "软壳衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22332,
                                "label": "软壳裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22333,
                                "label": "软壳衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21158,
                        "label": "抓绒衣裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22334,
                                "label": "抓绒裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22335,
                                "label": "抓绒衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22336,
                                "label": "抓绒衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21159,
                        "label": "保暖棉服",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22337,
                                "label": "保暖棉裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22338,
                                "label": "保暖棉衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22339,
                                "label": "保暖棉衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21160,
                        "label": "功能内衣内裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22340,
                                "label": "内衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22341,
                                "label": "功能内衣下装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22342,
                                "label": "功能内衣上装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22343,
                                "label": "功能内裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21161,
                        "label": "羽绒服",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22344,
                                "label": "羽绒裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22345,
                                "label": "羽绒衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22346,
                                "label": "羽绒衣裤套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 30012,
                        "label": "户外服饰配件",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 30013,
                        "label": "滑雪裤",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 30014,
                        "label": "滑雪衣裤套装",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 1999,
                "label": "户外鞋靴",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 2004,
                        "label": "登山鞋/徒步鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2011,
                        "label": "高海拔登山靴/攀冰鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2015,
                        "label": "户外休闲鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2021,
                        "label": "雪地靴",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2025,
                        "label": "攀岩鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2029,
                        "label": "沙滩鞋/凉鞋/拖鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2030,
                        "label": "溯溪鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2032,
                        "label": "越野跑鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    },
                    {
                        "value": 2033,
                        "label": "其他户外鞋",
                        "hierarchy": 3,
                        "open": true,
                        "children": []
                    }
                ]
            },
            {
                "value": 21162,
                "label": "军迷鞋服",
                "hierarchy": 2,
                "open": true,
                "children": [
                    {
                        "value": 21163,
                        "label": "军迷服装",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22347,
                                "label": "风衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22348,
                                "label": "吉利服/伪装服",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22349,
                                "label": "夹克",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22350,
                                "label": "军大衣/棉大衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22351,
                                "label": "裙子/迷彩裙",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22352,
                                "label": "休闲背心",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22353,
                                "label": "羽绒衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22354,
                                "label": "T恤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22355,
                                "label": "作训外套/套装/野战套装",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22356,
                                "label": "迷彩裤/军迷裤/工装裤",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22357,
                                "label": "毛衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22358,
                                "label": "卫衣",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22359,
                                "label": "战术背心",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22360,
                                "label": "衬衫",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "value": 21164,
                        "label": "军迷鞋靴",
                        "hierarchy": 3,
                        "open": true,
                        "children": [
                            {
                                "value": 22361,
                                "label": "解放鞋/回力鞋/帆布鞋",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            },
                            {
                                "value": 22362,
                                "label": "战术靴/飞行靴/沙漠靴",
                                "hierarchy": 4,
                                "open": true,
                                "children": []
                            }
                        ]
                    }
                ]
            }
        ],
        "hierarchy": 1,
        "label": "运动户外鞋服",
        "value": 1022,
        "open": true
    }
]
